import { CircularProgress } from '@mui/material';
import './WaitingSpinner.css';

import React from 'react';

const WaitingSpinner = ({ text = null, size = 30 }) => {
    return (
        <div className="spinner-container">
            <div className="spinner">
                <CircularProgress size={size} />
            </div>
            {text && <div className="spinner-text">{text}</div>}
        </div>
    );
};

export default WaitingSpinner;